import { Col, Row, Tabs } from "antd";
import React, { useEffect, useState } from "react";
import CardNews from "../../biblio/CardNews/CardNews";
import CarouselSlider from "../../biblio/Carousel/CarouselSlider";
import arrowleft from "../../assets/icons/arrow-left.svg";
import arrowright from "../../assets/icons/arrow-right.svg";
import { useTranslation } from "react-i18next";
import { AppDispatch, RootState } from "../../apis/store";
import { useDispatch, useSelector } from "react-redux";
import { getAllNews } from "../../apis/actions/news.actions";
import newsIcon from "../../assets/icons/news-icon.svg";
import {
  toGetPhotoAlbum,
  toGetVideoAlbum,
} from "../../apis/actions/photoVideos.actions";
import PreviewMedia from "../../biblio/PreviewMedia/PreviewMedia";

const NewsSection = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [activeTab, setActiveTab] = useState("news");

  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const { data: news } = useSelector((state: RootState) => state?.news?.news);
  const { photos, loading } = useSelector(
    (state: RootState) => state.photoVideo
  );
  const { videos } = useSelector((state: RootState) => state.photoVideo);
  useEffect(() => {
    dispatch(getAllNews());
    dispatch(toGetPhotoAlbum());
    dispatch(toGetVideoAlbum());
  }, [dispatch]);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getCols = () => {
    if (windowWidth < 768) return 1;
    if (windowWidth < 1025) return 2;
        if (windowWidth < 1281) return 3;

    return 4;
  };
  const getColsPhotos = () => {
    if (windowWidth < 768) return 1;
    if (windowWidth < 1024) return 2;
    return 3;
  };
  return (
    <Row className="takaful--news-container">
      <Col xxl={1} xl={1} lg={1} md={1} sm={1} xs={1} />
      <Col xxl={22} xl={22} lg={22} md={22} sm={22} xs={22}>
        <div className="takaful--news-title">
          <img
            src={newsIcon}
            alt="Partners Icon"
            className="takaful--partner-title-icon"
          />
          <span className="takaful--news-title-main">{t("news.subTitle")}</span>
        </div>

        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          className= "news_section_tab"
          items={[
            { key: "news", label: "الأخبار" },
            { key: "photos", label: "الصور" },
            { key: "videos", label: "الفيديوهات"},
          ]}
        />

        {activeTab === "news" && (
          <CarouselSlider
            cols={getCols()}
            rows={1}
            gap={20}
            autoPlays={5000}
            classLeft="takaful--news-arrow-left"
            classRight="takaful--news-arrow-right"
            imageLeft={arrowleft}
            imageRight={arrowright}
          >
            {news?.map((item: any) => (
              <CardNews
                key={item?.id}
                title={item?.title}
                description={item?.description}
                dateNews={item?.published_date}
                urlImage={`data:image/png;base64,${item?.image}`}
                id={item?.id}
              />
            ))}
          </CarouselSlider>
        )}

        {activeTab === "photos" && (
          <PreviewMedia
            mediaItems={photos || []}
            loading={loading}
            itemPerPage={getColsPhotos()}
            isVideo={false}
            title={""}
          />
        )}
        {activeTab === "videos" && (
          <PreviewMedia
            mediaItems={videos || []}
            loading={loading}
            itemPerPage={getColsPhotos()}
            isVideo={true}
            title={""}
          />
        )}
      </Col>
      <Col xxl={1} xl={1} lg={1} md={1} sm={1} xs={1} />
    </Row>
  );
};

export default NewsSection;
